import React,{useEffect} from 'react';
import { ReactSVG } from "react-svg";
import { useNavigate } from 'react-router-dom';

import './PageHeader.css';

function NavigateBackBtn({children}) {

  const navigate = useNavigate();

  return <div onClick={()=>{navigate(-1)}}>{children}</div>
}


/*
  pl.:

  <PageHeader parent_ref={this}  title={i18n.t('shoppingCartTitle')} custom_icons={[
    <ReactSVG className="edit" src="assets/images/edit_black.svg" onClick={() => this.edit()} />
  ]} />
*/

class PageHeader extends React.Component {

  constructor(props) {

    super(props);

    this.title = props.title ? props.title : '';
    this.isHistoryBack = (props.isHistoryBack) ? props.isHistoryBack : false;
    this.no_back = props.no_back ? props.no_back : false;
    this.no_close = props.no_close ? props.no_close : false;
    this.other_callback = props.callback ? props.callback : ()=>{};

    this.underline = props.underline ? props.underline : false;

    this.parent_ref = props.parent_ref ? props.parent_ref : null;

    this.state = {
      custom_icons: props.custom_icons ? props.custom_icons : []
    };

  }

  render() {
    const { custom_icons} = this.state;

    const callback = () => {

      if(!!this.parent_ref && !!this.parent_ref.hide){

        this.parent_ref.hide();

      }else{

        this.other_callback();

      }

    }

    let btn_back = null;

    if(this.isHistoryBack){
      btn_back = <NavigateBackBtn ><ReactSVG className="back" src="assets/images/arrow_down.svg" onClick={callback} /></NavigateBackBtn>
    }else{
      btn_back = <ReactSVG className="back" src="assets/images/arrow_down.svg" onClick={callback} />;
    }

    const btn_close = <ReactSVG className="close" src="assets/images/close.svg" onClick={callback} />;
    
    return (
      <div className={`page_header ${this.no_back ? 'no_back' : ''} ${this.no_close ? 'no_close' : ''} ${this.underline ? 'underline' : ''}`}>
        <div>
          {!this.no_back ? btn_back : ''}

          <h2>{this.title}</h2>

          <div className="right">
            
            {custom_icons.map((icon, index) => <div key={index}>{icon}</div>) /* egyedileg megadott ReactSVG elemek kiíratása */}

            {!this.no_close ? btn_close : ''}
          </div>
        </div>
      </div>
    );
  }
};

export default PageHeader;

